import type { buildPresetsEn } from './en.ts'
import { weaponsRu } from '../../weapons/locales/ru.ts'

export const buildPresetsRu: typeof buildPresetsEn = {
  names: weaponsRu.names,
  stages: {
    opening: 'Начало',
    forest: 'Лес',
    mid_push: 'Башни',
    late_defense: 'Гусь',
    endgame: 'Дерево',
    custom: 'Другое',
  },
  manager: {
    personalTitle: 'Мои пресеты этапов',
    personalDescription: 'Выберите сохранённую сборку для каждого этапа. «Башни» становятся основной сборкой рейда; пресеты доступны во всех гильдиях.',
    guildTitle: 'Пресеты этапов гильдии',
    guildDescription: 'Создавайте общие сборки по этапам. При применении пресета «Башни» становятся основной сборкой рейда.',
    count: (used: number, limit: number) => `${used} / ${limit} пресетов`,
    add: 'Добавить пресет',
    empty: 'Пресетов этапов пока нет.',
    noBuilds: 'Создайте хотя бы одну обычную сборку из двух оружий перед добавлением пресета.',
    name: 'Название пресета',
    namePlaceholder: 'Например: Основной сетап GvG',
    build: 'Сборка',
    buildNumber: (index: number) => `Сборка ${index}`,
    buildWithWeapons: (index: number, first: string, second: string) => `Сборка ${index}: ${first} + ${second}`,
    selectBuild: (stage: string) => `Выберите сборку для этапа «${stage}»`,
    edit: 'Изменить',
    remove: 'Удалить',
    save: 'Сохранить пресет',
    create: 'Создать пресет',
    cancel: 'Отмена',
    invalid: 'Введите название и выберите сборку из двух оружий для каждого этапа.',
    removeConfirm: (name: string) => `Удалить пресет этапов «${name}»?`,
    loading: 'Загрузка пресетов этапов…',
  },
  selector: {
    title: 'Пресеты этапов',
    hint: '«Башни» задают основу, остальные этапы — изменения',
    personal: 'Личный',
    guild: 'Гильдия',
    active: 'Применён',
    apply: (name: string) => `Применить пресет этапов «${name}»`,
  },
}
